import { Form, DatePicker } from 'antd';
import React from 'react';
import moment from 'moment';

const AlertDateForm = ({ form, request = {}, isRequred }) => {
  return (
    <Form>
      <Form.Item label="Дата контроля">
        {form.getFieldDecorator('alertDate', {
          initialValue: !!request?.alertDateTime
            ? moment(request.alertDateTime)
            : null,
          rules: [
            {
              required: !!isRequred,
              message: 'Пожалуйста укажитедату контроля',
            },
          ],
        })(
          <DatePicker
            style={{ width: '100%' }}
            allowClear={!isRequred}
            showTime={{ format: 'HH:mm' }}
            format="YYYY-MM-DD HH:mm"
          />
        )}
      </Form.Item>
    </Form>
  );
};

export default AlertDateForm;
